import { useMemo } from "react";
import { Box } from "orcs-design-system";

import GroupsNavigationLoader from "src/components/GroupsNavigation";
import {
  useWorkspaceTagConfig,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";

import TagTypeNavigation from "src/components/TagTypeNavigation";
import GoalsExploreContainer from "src/components/GoalsExplore/GoalsExploreContainer";

type ExploreTagTypeConfig = {
  id: string;
  name?: string | undefined;
  showInExplore?: boolean | undefined;
};

const asExploreTagConfigMap = (
  config: unknown
): Record<string, ExploreTagTypeConfig | undefined> => {
  if (config == null || typeof config !== "object") {
    return {};
  }
  return config as Record<string, ExploreTagTypeConfig | undefined>;
};

type ExploreMenuProps = {
  groupsNavProps?: Record<string, unknown> | undefined;
};

const ExploreMenu = ({ groupsNavProps }: ExploreMenuProps) => {
  const tagTypesConfig = asExploreTagConfigMap(useWorkspaceTagConfig());
  const featureFlags = useWorkspaceFeatureFlags();

  const tagTypes = useMemo(() => {
    return Object.entries(tagTypesConfig || {})
      .map(([id, config]) => ({
        ...(config ?? {}),
        id: config?.id ?? id,
      }))
      .filter((config) => config.showInExplore === true)
      .sort((a, b) =>
        String(a.name ?? a.id).localeCompare(String(b.name ?? b.id))
      );
  }, [tagTypesConfig]);

  return (
    <Box>
      <GroupsNavigationLoader {...groupsNavProps} />

      {tagTypes.map((tagType) => (
        <Box key={tagType.id} mt="r">
          <TagTypeNavigation
            tagType={{
              id: tagType.id,
              name: tagType.name ?? tagType.id,
            }}
          />
        </Box>
      ))}

      {featureFlags?.enableGoalsExplorer && (
        <Box mt="r">
          <GoalsExploreContainer />
        </Box>
      )}
    </Box>
  );
};

export default ExploreMenu;
